<script lang="ts">
	import { SystemScreenBreakpoints } from '@Shelly/shelly-design-system/helpers/enums';
	import { CardGrid, Container, Modal, SelectCard, Text } from '@Shelly/shelly-design-system/index';
	import { handleLogout } from 'src/helpers/account_helpers';
	import { showGlobalLoader } from 'src/stores/ui/global-loader';
	import { profiles } from 'src/stores/features/profiles';
	import { format } from 'src/services/i18n';
	import { capFirstChar } from 'src/helpers/utilities';
	import { getProfileDisplayName } from 'src/helpers/houses/homes_helpers';
	import { createEventDispatcher } from 'svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showModal;
	const dispatch = createEventDispatcher();

	let windowClientWidth: number;
	let activeProfile = $profiles.find((item) => item.isSelected);
	let profilesList = $profiles.filter((item) => item !== activeProfile);

	const onCloseModal = () => {
		showModal = false;
	};

	const onSelectCardClick = async (profileEmail) => {
		const newProfileToLogin = $profiles.find(
			(profile) => profile.email === profileEmail && !profile.isSelected,
		);

		$showGlobalLoader = true;
		onCloseModal();
		const result = await handleLogout(newProfileToLogin);
		$showGlobalLoader = false;
		if (result && 'pendingUnitSelection' in result) {
			dispatch('selectUnit', result);
		}
	};

	$: isMobile = windowClientWidth < SystemScreenBreakpoints.MOBILE_MAX;
</script>

<svelte:window bind:innerWidth={windowClientWidth} />

<Modal
	{showModal}
	title={$format('log_in_another_acc_title', {
		default: 'Log In Another Account',
	})}
	on:close={onCloseModal}
	removeScrollPadding
>
	<Container slot="content" padding="scrollPaddings">
		<Text class="mb-m" styleType="h2">
			{$format('choose_another_acc_login_prompt', {
				default: 'Choose another account to log in to',
			})}
		</Text>
		<CardGrid gridGap="s" sm={200} md={200} xl={200} noPaddingBottom>
			{#each profilesList as profile}
				{@const profileTitle = getProfileDisplayName(profile.title, profile.email ?? '')}
				<SelectCard
					cardBgColor={$showNewLayout ? 'color-1' : undefined}
					hideAction
					type={isMobile ? 'horizontal' : 'vertical'}
					class="width-full"
					image={profile?.acc_avatar?.image}
					title={profileTitle}
					backgroundColor={profile?.acc_avatar?.backgroundColor}
					circleAvatarText={profile?.acc_avatar?.text}
					on:click={() => onSelectCardClick(profile.email)}
					id={`login-another-profile-card-${profile.id}`}
					aria-label={$format('label_select_profile', {
						default: `Select profile ${profileTitle}`,
					})}
				/>
			{/each}
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				hideAction
				type={isMobile ? 'horizontal' : 'vertical'}
				class="width-full"
				icon="fat fa-plus"
				id="login-another-profile-add-card"
				aria-label={$format('button_profile_add', {
					default: 'Add another profile',
				})}
				title={capFirstChar(
					$format('button_profile_add', {
						default: 'Add another profile',
					}),
				)}
				on:click={() => {
					dispatch('add_another_profile');
				}}
			/>
		</CardGrid>
	</Container>
</Modal>
